import { FC } from 'react';

import MarketoForm from 'molecules/Form';
import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';
import { ConversionPanelConfigProps } from 'components/ConversionPanel/config';

import { useBuilderReference } from 'utils/hooks/useBuilderReference';

const ConversionPanel: FC<ConversionPanelConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);
  const { form, ...headingProps } = rest;

  const hasPreloadedForm = !!form?.value?.data;

  const formRefData = useBuilderReference(
    !hasPreloadedForm ? form?.model : undefined,
    !hasPreloadedForm ? form?.id : undefined,
  );
  const formData = hasPreloadedForm ? form.value.data : formRefData;

  return (
    <Section {...sectionProps} id={sectionProps.id || 'conversionpanelHidden'}>
      <div className="curve-t !absolute bottom-0 left-0 -z-10 block h-1/6 w-full bg-gray-900 dark:hidden lg:before:-top-20 lg:before:h-20" />
      <div className="flex flex-col justify-between gap-[60px] px-0 md:px-6 lg:flex-row lg:px-12 xl:px-24">
        <div className="w-full lg:mb-20 lg:w-1/2">
          <Heading {...headingProps} alignment="left" />
        </div>
        {(formData as FormReference) && (
          <div className="w-full lg:w-1/2">
            <ScrollFadeSection delay={0.2}>
              <MarketoForm formData={formData as FormReference} />
            </ScrollFadeSection>
          </div>
        )}
      </div>
    </Section>
  );
};

export default ConversionPanel;
